import React from "react";

import DropdownMenu from "../../../packages/excalidraw/components/dropdownMenu/DropdownMenu";
import { useOpenAgentsDrawer } from "./AgentsSidebar";
import { plugIcon } from "./plugIcon";

// "AI agents" in the toolbar's more-tools flyout, under Generate; rendered through `ExtraToolsSlot`.
export const AgentsToolbarItem: React.FC = () => {
  const openAgents = useOpenAgentsDrawer();
  return (
    <DropdownMenu.Item
      onSelect={openAgents}
      icon={plugIcon}
      data-testid="toolbar-agents"
    >
      AI agents
    </DropdownMenu.Item>
  );
};
